import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const OurWorksPage = lazy(() => import('../pages/our-works/page'));
const BathroomOffersPage = lazy(() => import('../pages/bathroom-offers/page'));
const ComplexHeatingPage = lazy(() => import('../pages/complex-heating/page'));
const SpecialOffersPage = lazy(() => import('../pages/special-offers/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/our-works',
    element: <OurWorksPage />,
  },
  {
    path: '/bathroom-offers',
    element: <BathroomOffersPage />,
  },
  {
    path: '/complex-heating',
    element: <ComplexHeatingPage />,
  },
  {
    path: '/special-offers',
    element: <SpecialOffersPage />,
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;